// Kroatische, gekürzte i-Texte (Module 01-03), erstellt 15.09.2026, gegenzulesen.
//
// Schlüssel und Aufbau wie INFO_TEIL1 / MODUL_INFO_TEIL1 in ../pruefpunktInfoTeil1.js.

export const MODUL_INFO_HR_TEIL1 = {
  '01-STATIONSKOERPER':
    'Građevinsko stanje stanice izvana i iznutra: zidovi, krov, vrata, pod, ventilacija, prozori i rasvjeta. Samo vizualna i funkcionalna provjera, bez rada na dijelovima pod naponom.',
  '02-MS-ANLAGE':
    'Vizualna provjera rasklopnog postrojenja srednjeg napona (SN) izvana. Otvaranje ili sklapanje samo s ovlaštenjem i odobrenjem odgovorne osobe, prema pet sigurnosnih pravila.',
  '03-NSHV':
    'Vizualna i funkcionalna provjera glavnog NN razdjelnika (NSHV): sklopni uređaji, podešenje prekidača transformatora, starost postrojenja i prenaponska zaštita. Ne skidati zaštitu od dodira dok je postrojenje pod naponom.',
};

export const INFO_HR_TEIL1 = {
  // ───────────── 01-STATIONSKOERPER ─────────────

  '01-STATIONSKOERPER|01.1': {
    was: 'Pregledati vanjske zidove i podnožje sa svih strana na pukotine, oštećenja i hrđu.',
    achten: [
      'Pukotine u betonu, osobito na uglovima i otvorima',
      'Otpali beton s vidljivom, zahrđalom armaturom',
      'Slijeganje: stanica stoji koso, procjep prema temelju',
    ],
    nio: 'Neispravno ako oštećenja prelaze obične površinske pukotine.',
    norm: 'DIN EN 62271-202 (VDE 0671-202) kod montažnih stanica; upute proizvođača',
  },
  '01-STATIONSKOERPER|01.1.1': {
    was: 'Provjeriti zidove iznutra i izvana na vlagu, plijesan i salitru.',
    achten: [
      'Tamne, vlažne mrlje ili tragovi vode',
      'Plijesan, miris vlage u prostoriji',
      'Bijele solne naslage (salitra) pri dnu zida',
    ],
    nio: 'Neispravno ako su vidljivi vlaga, plijesan ili salitra.',
    norm: 'DIN EN 61936-1 (VDE 0101-1); upute proizvođača',
  },
  '01-STATIONSKOERPER|01.1.2': {
    was: 'Provjeriti vanjske površine na grafite, naljepnice, plakate i strane natpise.',
    achten: [
      'Grafiti ili plakati prekrivaju upozorenja ili oznake',
      'Strani natpisi koji se mogu zamijeniti s oznakom stanice',
      'Naljepnice na rešetkama ventilacije ili vratima',
    ],
    nio: 'Neispravno ako postoje grafiti, nedopušteni natpisi ili plakati.',
    norm: 'Označavanje prema DIN VDE 0105-100; ETB zahtjev',
  },
  '01-STATIONSKOERPER|01.1.3': {
    was: 'Provjeriti brtvljenje fuga i prolaza za kabele i cijevi.',
    achten: [
      'Otvorene ili isprane fuge između zida, krova i poda',
      'Nebrtvljeni ulazi kabela, voda ili zemlja u kabelskom podrumu',
      'Nedostaje ili je ispucala brtvena masa',
    ],
    nio: 'Neispravno ako kroz fuge ili prolaze mogu ući voda, zemlja ili životinje.',
    norm: 'DIN EN 61936-1 (VDE 0101-1); upute proizvođača',
  },
  '01-STATIONSKOERPER|01.1.4': {
    was: 'Provjeriti oštećenja od vremenskih utjecaja ili izvana (udar vozila, vandalizam).',
    achten: [
      'Oštećenja od vozila, nedostaje zaštita od udara',
      'Korijenje ili raslinje oštećuje zid ili temelj',
      'Oštećenja od mraza, labave obloge',
    ],
    nio: 'Neispravno ako su vidljiva oštećenja od vremena ili vanjskog utjecaja.',
    norm: 'DIN EN 61936-1 (VDE 0101-1)',
  },

  '01-STATIONSKOERPER|01.2.1': {
    was: 'Provjeriti krov izvana (ako je sigurno) i strop iznutra na propuštanje.',
    achten: [
      'Mrlje od vode ili kapanje na stropu',
      'Pukotine, mjehuri ili rupe u hidroizolaciji',
      'Mahovina ili raslinje na krovu',
    ],
    nio: 'Neispravno ako krov propušta ili je pokrov vidljivo oštećen.',
    norm: 'Upute proizvođača; DIN EN 61936-1 (VDE 0101-1)',
  },
  '01-STATIONSKOERPER|01.2.2': {
    was: 'Provjeriti krov na oštećenja od oluje, tuče, grana ili vandalizma.',
    achten: [
      'Podignuti ili nedostajući dijelovi krova',
      'Grane ili strani predmeti na krovu',
      'Udubljenja, rupe, tragovi hodanja ili vandalizma',
    ],
    nio: 'Neispravno ako na krovu postoje oštećenja od vremena ili vanjskog utjecaja.',
    norm: 'Upute proizvođača',
  },
  '01-STATIONSKOERPER|01.2.3': {
    was: 'Provjeriti rubove krova, limove, oluke i odvode na stanje i slobodan protok.',
    achten: [
      'Začepljeni oluci ili odvodi (lišće, prljavština)',
      'Labavi, savijeni ili zahrđali limovi',
      'Voda curi niz fasadu ili iznad vrata',
    ],
    nio: 'Neispravno ako su završeci krova oštećeni ili voda ne otječe slobodno.',
    norm: 'Upute proizvođača',
  },

  '01-STATIONSKOERPER|01.3.1': {
    was: 'Otvoriti i zatvoriti sva vrata: šarke i zatvaranje moraju raditi lako i sigurno.',
    achten: [
      'Vrata stružu, zapinju ili se ne zatvaraju sama',
      'Istrošene, zahrđale ili labave šarke',
      'Vrata se ne mogu potpuno zatvoriti',
    ],
    nio: 'Neispravno ako se vrata ne otvaraju lako ili ne zatvaraju sigurno.',
    norm: 'DIN EN 61936-1 (VDE 0101-1)',
  },
  '01-STATIONSKOERPER|01.3.2': {
    was: 'Zaključati i otključati bravu ključem: cilindar i zasun moraju ići lako.',
    achten: [
      'Ključ se okreće teško ili samo na silu',
      'Zahrđao, prljav ili zaleđen cilindar',
      'Zasun ne ulazi pravilno u prihvatnik',
    ],
    nio: 'Neispravno ako je brava teška, oštećena ili se ne može sigurno zaključati.',
    norm: 'DIN VDE 0105-100 (zaštita od pristupa neovlaštenih)',
  },
  '01-STATIONSKOERPER|01.3.3': {
    was: 'Iznutra provjeriti otvaraju li se vrata uvijek bez ključa (panik brava).',
    achten: [
      'Vrata se iznutra ne otvaraju bez ključa',
      'Panik kvaka nedostaje, zapinje ili je blokirana',
      'Vrata se ne otvaraju prema van',
    ],
    nio: 'Neispravno ako se vrata iznutra ne mogu odmah otvoriti bez pomagala.',
    norm: 'DIN EN 61936-1 (VDE 0101-1)',
  },
  '01-STATIONSKOERPER|01.3.4': {
    was: 'Provjeriti vrata, dovratnik i bravu na deformacije i tragove provale.',
    achten: [
      'Tragovi poluge na bravi ili dovratniku',
      'Savijeno krilo vrata, procjep prema dovratniku',
      'Oštećen ili zamijenjen cilindar',
    ],
    nio: 'Neispravno ako postoje deformacije ili tragovi provale (obavijestiti i vlasnika).',
    norm: 'DIN VDE 0105-100',
  },
  '01-STATIONSKOERPER|01.3.5': {
    was: 'Provjeriti postoji li graničnik vrata koji sigurno drži otvorena vrata.',
    achten: [
      'Graničnik nedostaje ili je slomljen',
      'Vrata se na vjetru ipak zalupe',
      'Graničnik zahrđao ili težak',
    ],
    nio: 'Neispravno ako graničnik nedostaje ili vrata ne drži sigurno otvorena.',
    norm: 'Upute proizvođača; procjena rizika (GBU)',
  },
  '01-STATIONSKOERPER|01.3.6': {
    was: 'Provjeriti postoji li dvostruko zaključavanje za pristup operatora mreže (VNB).',
    achten: [
      'Samo jedan cilindar, nema VNB brave',
      'VNB cilindar postoji, ali je neispravan ili pogrešan sustav',
    ],
    nio: 'Neispravno ako dvostruko zaključavanje koje traži VNB nedostaje ili ne radi.',
    norm: 'TAB srednjeg napona operatora mreže (VDE-AR-N 4110)',
  },
  '01-STATIONSKOERPER|01.3.7': {
    was: 'Provjeriti imaju li vanjske brave kapice protiv kiše.',
    achten: [
      'Kapica nedostaje → odabrati „nedostaje"',
      'Kapica slomljena, savijena ili ne zatvara → „oštećeno"',
      'Voda ili hrđa u cilindru',
    ],
    nio: 'Neispravno odn. „nedostaje"/„oštećeno" ako brava nije zaštićena ispravnom kapicom.',
    norm: 'Upute proizvođača',
  },

  '01-STATIONSKOERPER|01.4.1': {
    was: 'Provjeriti prostoriju, kabelski podrum i pod na vlagu, kondenzat i stajaću vodu.',
    achten: [
      'Lokve ili voda u kabelskom podrumu',
      'Kondenzat na stropu, zidovima ili opremi',
      'Tragovi hrđe ili kapanje na rasklopnom postrojenju',
    ],
    nio: 'Neispravno ako u prostoriji ima vlage, kondenzata ili stajaće vode.',
    norm: 'DIN EN 61936-1 (VDE 0101-1); upute proizvođača rasklopnog postrojenja',
  },
  '01-STATIONSKOERPER|01.4.2': {
    was: 'Pregledati prostoriju na hrđu i labave dijelove (nosači, pokrovi, kabelske police, pločice).',
    achten: [
      'Hrđa na nosačima, policama, držačima',
      'Labavi ili obješeni pokrovi i pričvrsnice',
      'Razbacani dijelovi ili alat',
    ],
    nio: 'Neispravno ako postoje korozija ili labavi dijelovi.',
    norm: 'DIN VDE 0105-100',
  },
  '01-STATIONSKOERPER|01.4.3': {
    was: 'Provjeriti prostoriju i kabelski podrum na životinje i njihove tragove.',
    achten: [
      'Izmet miševa ili kuna, gnijezda u podrumu',
      'Izgrizena izolacija kabela',
      'Gnijezda insekata ili osa',
    ],
    nio: 'Neispravno ako su vidljivi štetočine ili njihovi svježi tragovi.',
    norm: 'DIN VDE 0105-100',
  },
  '01-STATIONSKOERPER|01.4.4': {
    was: 'Provjeriti nosivu konstrukciju ispod poda i podne ploče na nosivost i stanje.',
    achten: [
      'Savijene, slomljene ili klimave podne ploče',
      'Zahrđali ili deformirani nosači',
      'Nedostaju ploče, otvorene rupe (opasnost od pada)',
    ],
    nio: 'Neispravno ako su ploče ili nosači oštećeni, labavi ili nesigurni za hodanje.',
    norm: 'DIN EN 61936-1 (VDE 0101-1); procjena rizika (GBU)',
  },
  '01-STATIONSKOERPER|01.4.5': {
    was: 'Provjeriti jesu li podne ploče u SN prostoru čvrsto vijcima pričvršćene (tlak električnog luka).',
    achten: [
      'Nedostaju ili labavi vijci na pločama',
      'Ploče se mogu podići ili pomaknuti',
    ],
    nio: 'Neispravno ako podne ploče u SN prostoru nisu potpuno pričvršćene.',
    norm: 'Upute proizvođača stanice; DIN EN 62271-202 (VDE 0671-202)',
  },

  '01-STATIONSKOERPER|01.5': {
    was: 'Provjeriti ventilaciju i rasterećenje tlaka kao cjelinu: dovod/odvod zraka, rešetke, žaluzine i zaklopke, zaštitu od prodora i put za rasterećenje.',
    achten: [
      'Ventilacija postoji, zrak slobodno struji (bez lišća, bez stranih tijela)',
      'Rešetke neoštećene, čvrste, bez hrđe; bez životinja (oprez – ose)',
      'Žaluzine/zaklopke pomične; zaštita od prodora postoji i neoštećena',
      'Bez deformacija ili tragova provale; put za rasterećenje slobodan',
    ],
    nio: 'Neispravno čim nešto ne odgovara – tada dolje dodirni sve razloge koji vrijede.',
    norm: 'DIN EN 62271-202 (VDE 0671-202); DIN EN 61936-1 (VDE 0101-1); upute proizvođača',
  },
  '01-STATIONSKOERPER|01.5.1': {
    was: 'Utvrditi postoji li ventilacija (rešetke, žaluzine, ventilatori). Samo evidencija.',
    achten: [
      'Postoji li dovod zraka dolje i odvod gore?',
      'Kod „ne": toplina transformatora se ne odvodi – upisati u izvještaj',
    ],
    nio: 'Nema ispravno/neispravno: odabrati „da" ili „ne".',
    norm: 'DIN EN 62271-202 (VDE 0671-202); upute proizvođača',
  },
  '01-STATIONSKOERPER|01.5.2': {
    was: 'Provjeriti struji li zrak nesmetano kroz otvore ventilacije.',
    achten: [
      'Lišće, prljavština ili paučina u rešetkama i filtrima',
      'Raslinje, snijeg ili predmeti ispred otvora',
    ],
    nio: 'Neispravno ako su otvori djelomično ili potpuno začepljeni.',
    norm: 'DIN EN 62271-202 (VDE 0671-202); upute proizvođača',
  },
  '01-STATIONSKOERPER|01.5.3': {
    was: 'Provjeriti rešetke ventilacije na mehanička oštećenja.',
    achten: [
      'Savijene, utisnute ili izlomljene lamele',
      'Rupe kroz koje mogu ući životinje ili predmeti',
    ],
    nio: 'Neispravno ako je rešetka mehanički oštećena.',
    norm: 'DIN EN 62271-202 (VDE 0671-202)',
  },
  '01-STATIONSKOERPER|01.5.4': {
    was: 'Provjeriti otvore ventilacije i prostor iza njih na životinje.',
    achten: [
      'Gnijezda osa ili stršljena (oprez pri otvaranju)',
      'Ptičja gnijezda, perje, izmet',
      'Tragovi miševa ili kuna iza rešetke',
    ],
    nio: 'Neispravno ako u ventilaciji ili na njoj ima životinja ili gnijezda.',
    norm: 'DIN VDE 0105-100',
  },
  '01-STATIONSKOERPER|01.5.5': {
    was: 'Provjeriti rad pomičnih dijelova ventilacije (žaluzine, zaklopke, ventilatori).',
    achten: [
      'Žaluzina ili zaklopka blokirana ili zahrđala',
      'Ventilator ne radi ili je bučan',
    ],
    nio: 'Neispravno ako su pomični dijelovi blokirani, začepljeni ili ne rade.',
    norm: 'Upute proizvođača',
  },
  '01-STATIONSKOERPER|01.5.6': {
    was: 'Provjeriti rešetke i okvire na hrđu i čvrsto pričvršćenje.',
    achten: [
      'Hrđa na rešetki, okviru ili vijcima',
      'Rešetka se klima ili se može izvući izvana',
    ],
    nio: 'Neispravno ako postoji korozija ili je pričvršćenje labavo.',
    norm: 'Upute proizvođača',
  },
  '01-STATIONSKOERPER|01.5.7': {
    was: 'Provjeriti put zraka (dovod, transformator, odvod) na strane predmete.',
    achten: [
      'Grane, plastične vrećice, papir u kanalu',
      'Uskladišten materijal koji ometa strujanje zraka',
    ],
    nio: 'Neispravno ako se na putu zraka nalaze strani predmeti.',
    norm: 'Upute proizvođača',
  },
  '01-STATIONSKOERPER|01.5.8': {
    was: 'Provjeriti postoji li iza otvora ventilacije ispravna zaštitna mrežica protiv prodora.',
    achten: [
      'Mrežica nedostaje – žica ili štap mogu dosegnuti dijelove pod naponom',
      'Mrežica poderana, utisnuta ili labava',
    ],
    nio: 'Neispravno ako zaštita od prodora nedostaje ili je oštećena.',
    norm: 'DIN EN 62271-202 (VDE 0671-202); DIN EN 61936-1 (VDE 0101-1)',
  },
  '01-STATIONSKOERPER|01.5.9': {
    was: 'Provjeriti rešetke i zaklopke na deformacije i tragove provale.',
    achten: [
      'Savijene ili izvaljene rešetke',
      'Tragovi alata na pričvrsnicama',
    ],
    nio: 'Neispravno ako postoje deformacije ili tragovi provale (obavijestiti vlasnika).',
    norm: 'DIN VDE 0105-100',
  },
  '01-STATIONSKOERPER|01.5.10': {
    was: 'Provjeriti je li put rasterećenja tlaka (električni luk) slobodan.',
    achten: [
      'Materijal, palete ili vozila ispred otvora za rasterećenje',
      'Zakrčen prostor iznad/ispod rasklopnog postrojenja',
    ],
    nio: 'Neispravno ako je put rasterećenja prekriven ili zakrčen.',
    norm: 'DIN EN 62271-202 (VDE 0671-202); upute proizvođača',
  },
  '01-STATIONSKOERPER|01.5.11': {
    was: 'Provjeriti zaklopke za rasterećenje tlaka na deformacije, npr. nakon prorade.',
    achten: [
      'Ispupčene ili otvorene zaklopke',
      'Tragovi čađe ili miris paljevine (električni luk)',
    ],
    nio: 'Neispravno ako postoji deformacija ili znak prorade rasterećenja tlaka.',
    norm: 'DIN EN 62271-202 (VDE 0671-202); upute proizvođača',
  },

  '01-STATIONSKOERPER|01.6.1': {
    was: 'Utvrditi ima li stanica prozore, staklene blokove ili druge staklene elemente.',
    achten: [
      'Ubrojiti i male staklene blokove u zidu',
      'Staklo može puknuti od tlaka električnog luka',
      'Broj i položaj upisati u napomenu',
    ],
    nio: 'Poseban slučaj: „postoji" je nedostatak (crveno), „ne postoji" je ispravno. Obrazloženje nije potrebno.',
    norm: 'ETB zahtjev',
  },
  '01-STATIONSKOERPER|01.6.2': {
    was: 'Poseban slučaj: „postoji = nedostatak". Staklo u stanici prema ETB zahtjevu nije dopušteno.',
    achten: [
      'Staklo je slaba točka kod provale i vandalizma',
      'Staklo može puknuti od tlaka električnog luka',
      'Broj i položaj upisati u napomenu',
    ],
    nio: 'Uvijek „neispravno jer nije dopušteno" ako staklo postoji.',
    norm: 'ETB zahtjev',
  },

  '01-STATIONSKOERPER|01.7': {
    was: 'Provjeriti unutarnju rasvjetu kao cjelinu: uključiti, pregledati svjetiljke, aktivirati prekidače i kontakte vrata.',
    achten: [
      'Sve svjetiljke svijetle i dovoljno su svijetle (i u prostoru za rukovanje i kabele)',
      'Poklopci i kućišta potpuni, nisu slomljeni; svjetiljka čvrsta',
      'Prekidači i kontakt vrata pouzdano uključuju',
    ],
    nio: 'Neispravno čim nešto ne odgovara – tada dolje dodirni razloge koji vrijede.',
    norm: 'DIN EN 61936-1 (VDE 0101-1); DIN VDE 0105-100',
  },
  '01-STATIONSKOERPER|01.7.1': {
    was: 'Uključiti rasvjetu u svim prostorijama i provjeriti rade li sve svjetiljke dovoljno jako.',
    achten: [
      'Žarulja neispravna ili treperi',
      'Prostor za posluživanje i kabele ostaje taman',
    ],
    nio: 'Neispravno ako svjetiljka ne radi ili rasvjeta nije dovoljna za siguran rad.',
    norm: 'DIN EN 61936-1 (VDE 0101-1)',
  },
  '01-STATIONSKOERPER|01.7.2': {
    was: 'Provjeriti vanjsko stanje svjetiljki: pokrove, kućišta i pričvršćenje.',
    achten: [
      'Slomljen ili nedostaje pokrov',
      'Voda ili mrtvi insekti u kućištu',
      'Svjetiljka labavo visi',
    ],
    nio: 'Neispravno ako pokrovi nedostaju ili su oštećeni ili je svjetiljka labava.',
    norm: 'DIN VDE 0105-100',
  },
  '01-STATIONSKOERPER|01.7.3': {
    was: 'Pritisnuti prekidače svjetla i kontakte vrata: svjetlo se mora pouzdano paliti i gasiti.',
    achten: [
      'Prekidač neispravan, labav ili slomljen pokrov',
      'Kontakt vrata ne pali svjetlo pri otvaranju',
      'Prekidač nije dostupan odmah kod ulaza',
    ],
    nio: 'Neispravno ako prekidači ili kontakti vrata ne rade pouzdano ili su oštećeni.',
    norm: 'DIN VDE 0105-100',
  },

  // ───────────── 02-MS-ANLAGE ─────────────

  '02-MS-ANLAGE|02.1': {
    was: 'Očitati pokazivač tlaka plina na plinom izoliranim postrojenjima (SF6 ili Clean Air).',
    achten: [
      'Kazaljka u zelenom? Crveno = premalo plina',
      'Aktivna poruka održavanja ili smetnje',
      'Zrakom izolirano postrojenje → „nije potrebno"',
    ],
    nio: 'Neispravno ako je tlak izvan dopuštenog – tada ne sklapati i obavijestiti ured.',
    norm: 'Upute proizvođača; DIN EN 62271-200 (VDE 0671-200)',
  },
  '02-MS-ANLAGE|02.2': {
    was: 'Provjeriti kućište/ormar postrojenja i vidljive izolacijske dijelove – samo vidljivo, ništa ne otvarati.',
    achten: [
      'Udubljenja, pukotine ili hrđa na kućištu; vrata/pokrov se zatvaraju i zaključavaju',
      'Priključak uzemljenja na kućištu postoji i čvrst je',
      'Pukotine na izolatorima, naslage prašine/vlage, tamni tragovi puzajućih struja',
      'Promjena boje, tragovi gorenja, miris ozona',
    ],
    nio: 'Neispravno čim nešto od toga vrijedi – tada dolje dodirni razloge.',
    norm: 'DIN EN 62271-200 (VDE 0671-200); DIN VDE 0105-100; upute proizvođača',
  },
  '02-MS-ANLAGE|02.3': {
    was: 'Provjeriti vidljive izolacijske dijelove na pukotine, prljavštinu i promjenu boje – ništa ne otvarati.',
    achten: [
      'Pukotine ili odlomljeni dijelovi izolatora',
      'Naslage prašine ili vlage, tamni tragovi puzajućih struja',
      'Promjena boje, tragovi gorenja, miris ozona',
    ],
    nio: 'Neispravno ako su vidljive pukotine, tragovi puzajućih struja ili promjena boje.',
    norm: 'DIN VDE 0105-100; upute proizvođača',
  },
  '02-MS-ANLAGE|02.4': {
    was: 'Provjeriti vidljive SN kabelske priključke i završetke na oštećenja i pričvršćenje.',
    achten: [
      'Oštećen plašt kabela ili kabelski završetak',
      'Kabel visi na priključku, nedostaje obujmica',
      'Promjena boje ili tragovi gorenja na priključku',
    ],
    nio: 'Neispravno ako postoje oštećenja izolacije, labavi priključci ili nema rasterećenja vlaka.',
    norm: 'DIN VDE 0105-100; upute proizvođača',
  },
  '02-MS-ANLAGE|02.5': {
    was: 'Provjeriti vidljive spojeve uzemljenja SN postrojenja (sabirnica, vodiči, ekrani kabela).',
    achten: [
      'Labavi, otkinuti ili nedostajući vodiči uzemljenja',
      'Korozija na stezaljkama i sabirnicama',
      'Vodiči uočljivo tanji od ostalih',
    ],
    nio: 'Neispravno ako je spoj uzemljenja labav, korodiran, prekinut ili preslab.',
    norm: 'DIN EN 50522 (VDE 0101-2); DIN EN 61936-1 (VDE 0101-1)',
  },
  '02-MS-ANLAGE|02.6': {
    was: 'Očitati pokazivače položaja sklopnih aparata i usporediti sa stvarnim stanjem.',
    achten: [
      'Pokazivač ne odgovara očekivanom stanju',
      'Prozorčić prljav, razbijen ili nečitljiv',
      'Aktivna poruka o isklopu (utvrditi uzrok, ne samo resetirati)',
    ],
    nio: 'Neispravno ako je pokazivač nejasan, pogrešan, oštećen ili ne radi.',
    norm: 'DIN EN 62271-200 (VDE 0671-200); DIN VDE 0105-100',
  },
  '02-MS-ANLAGE|02.7': {
    was: 'Ocijeniti hod sklopnog mehanizma. Sklapanje samo s ovlaštenjem i nalogom.',
    achten: [
      'Pogon težak ili zaglavljen',
      'Poluga se ne može umetnuti ili ne uskoči',
      'Blokade (npr. zemljospojnik/rastavljač) ne rade',
    ],
    nio: 'Neispravno ako je sklopka teška, zapinje ili blokada ne radi.',
    norm: 'DIN VDE 0105-100; upute proizvođača',
  },
  '02-MS-ANLAGE|02.8': {
    was: 'Provjeriti zaštitne i pokazne uređaje na vidljiva oštećenja.',
    achten: [
      'Razbijeno staklo ili napukli zaslon',
      'Uređaj bez prikaza, svijetli LED greške',
      'Pokazivač kratkog spoja prorađen (upisati u izvještaj)',
    ],
    nio: 'Neispravno ako je uređaj vidljivo oštećen ili javlja smetnju.',
    norm: 'Upute proizvođača; DIN VDE 0105-100',
  },
  '02-MS-ANLAGE|02.9': {
    was: 'Provjeriti može li se svako SN polje uzemljiti (zemljospojnik ili točke za garnituru).',
    achten: [
      'Polje bez zemljospojnika i bez kuglastih točaka',
      'Zemljospojnik postoji, ali je neispravan',
    ],
    nio: 'Neispravno ako se polje ne može sigurno uzemljiti i kratko spojiti.',
    norm: 'DIN VDE 0105-100 (pet sigurnosnih pravila); DIN EN 61936-1 (VDE 0101-1)',
  },
  '02-MS-ANLAGE|02.10': {
    was: 'Provjeriti isključuje li udarna igla VN osigurača sklopku transformatora svepolno. Samo s ovlaštenjem u isključenom polju.',
    achten: [
      'Mehanizam okidanja težak ili blokiran',
      'Pogrešan VN osigurač bez odgovarajuće udarne igle',
      'Polje bez VN osigurača → „nije potrebno"',
    ],
    nio: 'Neispravno ako udarna igla ne okida sklopku transformatora pouzdano.',
    norm: 'DIN 43625 (VN osigurači); upute proizvođača',
  },
  '02-MS-ANLAGE|02.11': {
    was: 'Provjeriti isključuje li se pri isklopu SN sklopke transformatora i NN prekidač transformatora.',
    achten: [
      'NN prekidač ostaje uključen',
      'Vod ili pomoćni kontakt za isklop nedostaje',
      'Isklop nije predviđen → „nije potrebno"',
    ],
    nio: 'Neispravno ako predviđeni isklop NN prekidača ne radi.',
    norm: 'Koncept zaštite postrojenja; upute proizvođača',
  },
  '02-MS-ANLAGE|02.12': {
    was: 'Očitati godinu proizvodnje SN postrojenja s natpisne pločice: 30 godina ili starije (vijek trajanja prema AMEV/VDI/HEA)?',
    achten: [
      'Godina na natpisnoj pločici, inače u dokumentaciji',
      'Proizvođač više ne isporučuje rezervne dijelove?',
    ],
    nio: 'Nema ispravno/neispravno: „da" ako 30 godina ili starije (preporučiti zamjenu), inače „ne".',
    norm: 'AMEV / VDI / HEA',
  },

  // ───────────── 03-NSHV ─────────────

  '03-NSHV|03': {
    was: 'Utvrditi ima li stanica vlastiti glavni niskonaponski razdjelnik (NNGR).',
    achten: [
      '„postoji": tada se pojavljuju točke za NNGR',
      '„ne postoji": nema daljnjih pitanja, dalje s transformatorom – to nije nedostatak',
    ],
    nio: 'Nema ispravno/neispravno – samo evidencija.',
    norm: '–',
  },

  '03-NSHV|03.1': {
    was: 'Ocijeniti rad i stanje NN sklopnih aparata. Sklapanje samo s ovlaštenjem i dogovorom.',
    achten: [
      'Aparat težak, zapinje ili ne uskoči',
      'Tragovi gorenja, promjena boje ili miris',
      'Nedostaju pokrovi, zaštita od dodira ili pogrešni osigurači',
    ],
    nio: 'Neispravno ako aparat ne radi besprijekorno ili je vidljivo oštećen.',
    norm: 'DIN VDE 0105-100; DIN EN 61439-1/-2 (VDE 0660-600)',
  },
  '03-NSHV|03.2': {
    was: 'Očitati podešenje NN prekidača transformatora i usporediti s nazivnom strujom transformatora.',
    achten: [
      'Podešenje preopterećenja (Ir) ne odgovara nazivnoj struji',
      'Regulator nije plombiran ili nije čitljiv',
      'Nazivna struja nepoznata → fotografirati natpisnu pločicu',
    ],
    nio: 'Nema ispravno/neispravno: „ne" ako podešenje ne odgovara nazivnoj struji.',
    norm: 'DIN VDE 0100-430; upute proizvođača',
  },
  '03-NSHV|03.3': {
    was: 'Očitati godinu proizvodnje NN postrojenja: 25 godina ili starije?',
    achten: [
      'Godina na natpisnoj pločici ili u dokumentaciji',
      'Zastarjela izvedba, npr. otvorene sabirnice bez zaštite od dodira',
    ],
    nio: 'Nema ispravno/neispravno: „da" ako 25 godina ili starije (preporučiti zamjenu), inače „ne".',
    norm: 'AMEV / VDI 2067',
  },
  '03-NSHV|03.4': {
    was: 'Provjeriti postoji li prenaponska zaštita (SPD). Samo kod „da" slijede pitanja o osiguranju i priključku.',
    achten: [
      'Nema prenaponske zaštite → „ne" (nedostatak)',
      'Crveni pokazivač ili prorađen modul → kod 03.6 označiti kao neispravno',
    ],
    nio: '„ne" je nedostatak. „da" znači samo: postoji – stanje i priključak slijede.',
    norm: 'DIN VDE 0100-534; DIN VDE 0100-443',
  },
  '03-NSHV|03.5': {
    was: 'Provjeriti odgovara li predosigurač prenaponske zaštite uputama proizvođača.',
    achten: [
      'Vrijednost osigurača veća od dopuštene',
      'Nema predosigurača iako ga proizvođač traži',
      'Nema tehničkog lista → zapisati tip, ured provjerava',
    ],
    nio: 'Neispravno ako osiguranje ne odgovara uputama proizvođača.',
    norm: 'Upute proizvođača; DIN VDE 0100-534',
  },
  '03-NSHV|03.6': {
    was: 'Provjeriti priključak prenaponske zaštite: presjeci, čvrste stezaljke, kratki vodovi prema PE.',
    achten: [
      'Ukupna duljina priključnih vodova preko 0,5 m → „PE priključak >0,5m"',
      'Tip ne odgovara mjestu ugradnje (npr. tip 3 umjesto 1/2) → „pogrešan tip"',
      'Crveni pokazivač ili prorađen modul',
      'Vodovi s petljama umjesto kratko i ravno',
      'Labave stezaljke, premali presjek',
    ],
    nio: 'Neispravno ako priključak nije izveden prema uputama proizvođača i DIN VDE.',
    norm: 'DIN VDE 0100-534; upute proizvođača',
  },
};
